// app/javascript/controllers/venue_attendees_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static targets = ["list", "template", "guestNames"]

    connect() {
        this.form = this.element.closest("form")
        this.countInput = this.form?.querySelector('[name="guests"]')

        this.boundSync = this.sync.bind(this)

        this.countInput?.addEventListener("input", this.boundSync)
        this.countInput?.addEventListener("change", this.boundSync)

        this.nextIndex = this.rows.reduce((highest, row) => {
            const value = Number.parseInt(row.dataset.index, 10)
            return Number.isNaN(value) ? highest : Math.max(highest, value)
        }, -1) + 1

        this.sync()
    }

    disconnect() {
        this.countInput?.removeEventListener("input", this.boundSync)
        this.countInput?.removeEventListener("change", this.boundSync)
    }

    sync() {
        const requested = Number.parseInt(this.countInput?.value || "1", 10)
        const desired = Math.min(99, Math.max(1, requested || 1))

        while (this.rows.length < desired) {
            this.addRow()
        }

        while (this.rows.length > desired) {
            const rows = this.rows
            rows[rows.length - 1]?.remove()
        }

        this.relabelRows()
        this.applyAllergyStates()
        this.syncGuestNames()
    }

    addRow() {
        const index = this.nextIndex++
        const html = this.templateTarget.innerHTML.replace(/__INDEX__/g, index)

        this.listTarget.insertAdjacentHTML("beforeend", html)
    }

    toggleAllergies(event) {
        const row = event.target.closest("[data-venue-attendee-row]")
        const details = row?.querySelector("[data-allergy-details]")

        if (!details) return

        if (event.target.checked) {
            details.value = ""
            details.disabled = true
        } else {
            details.disabled = false
            details.focus()
        }
    }

    syncGuestNames() {
        if (!this.hasGuestNamesTarget) return

        const names = this.rows
            .map((row) => {
                return row.querySelector('input[name$="[name]"]')?.value?.trim()
            })
            .filter(Boolean)

        this.guestNamesTarget.value = names.join(", ")
    }

    relabelRows() {
        this.rows.forEach((row, index) => {
            const label = row.querySelector("[data-venue-attendee-number]")
            if (label) label.textContent = index + 1
        })
    }

    applyAllergyStates() {
        this.rows.forEach((row) => {
            const checkbox = row.querySelector(
                'input[name$="[no_known_allergies]"]'
            )
            const details = row.querySelector("[data-allergy-details]")

            if (checkbox && details) {
                details.disabled = checkbox.checked
            }
        })
    }

    get rows() {
        return Array.from(
            this.listTarget.querySelectorAll("[data-venue-attendee-row]")
        )
    }
}